import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import SearchModal from '../../../../SiteHeader/_partials/SearchModal';
var SearchIconButton = function (_a) {
    var className = _a.className, isSearchModalShown = _a.isSearchModalShown, openSearchModal = _a.openSearchModal, closeSearchModal = _a.closeSearchModal;
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: className, size: "medium", icon: SearchIcon, biData: BiData({
                evid: 700,
                link_name: 'search',
            }), onClick: openSearchModal }),
        isSearchModalShown && React.createElement(SearchModal, { onClose: closeSearchModal })));
};
SearchIconButton.displayName = 'SearchIconButton';
export default SearchIconButton;
//# sourceMappingURL=SearchIconButton.js.map